import { LegalPage } from '@/pages/LegalLayout';

export default function Terms() {
  return <LegalPage base="legal.terms" />;
}
